export default __webpack_public_path__ + "static/media/protoAndGoIconDark.51dd6b2a.png";